export const FORM_MODES = {
  VIEW: "view",
  EDIT: "edit",
  ADD: "add",
};

export const roles = {
  REMIXER: "REMIXER",
  ADMIN: "ADMIN",
};

// INFO: Order Statuses
export const orderStatus = {
  ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS",
  ORDER_DELIVERED: "ORDER_DELIVERED",
  IN_REVISION: "IN_REVISION",
  COMPLETED: "COMPLETED",
  COMPLAINT_RAISED: "COMPLAINT_RAISED",
  COMPLAINT_RESOLVED: "COMPLAINT_RESOLVED",
  ISSUE_RAISED: "ISSUE_RAISED",
  ISSUE_RESOLVED: "ISSUE_RESOLVED",
};

// INFO: Tasker Status
export const taskerStatus = {
  REGISTERED: "REGISTERED",
  UN_REGISTERED: "UN_REGISTERED",
};

export const orderStatusForDropdown = [
  { label: "Order In Progress", id: "ORDER_IN_PROGRESS" },
  { label: "Delivered", id: "ORDER_DELIVERED" },
  { label: "Completed", id: "COMPLETED" },
  { label: "Complaint Raised", id: "COMPLAINT_RAISED" },
  { label: "Resolved", id: "COMPLAINT_RESOLVED" },
  { label: "In Revision", id: "IN_REVISION" },
  { label: "Issue Raised", id: "ISSUE_RAISED" },
  { label: "Issue Resolved", id: "ISSUE_RESOLVED" },
];

export const referencesFormats = {
  JPEG_JPG: { mime: "image/jpeg", extensions: [".jpeg", ".jpg"] },
  PNG: { mime: "image/png", extensions: [".png"] },
  PDF: { mime: "application/pdf", extensions: [".pdf"] },
  DOC: { mime: "application/msword", extensions: [".doc"] },
  DOCX: {
    mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extensions: [".docx"],
  },
  XLSX: {
    mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extensions: [".xlsx"],
  },
  PPTX: {
    mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    extensions: [".pptx"],
  },
  CSV: { mime: "text/csv", extensions: [".csv"] },
  TXT: { mime: "text/plain", extensions: [".txt"] },
  ZIP: { mime: "application/zip", extensions: [".zip"] },
  RAR: { mime: "application/vnd.rar", extensions: [".rar"] },
};

export const revitionStatus = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
};

export const issueStatus = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
};

export const issueStatusForDropdown = [
  { label: "Pending", id: "PENDING" },
  { label: "Resolved", id: "RESOLVED" },
];

export const complaintStatus = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
};

export const complaintStatusForDropdown = [
  { label: "Pending", id: "PENDING" },
  { label: "Resolved", id: "RESOLVED" },
];

// NOTE: old >>>>>>>>>>>>
// export const categories = [
//   {
//     _id: "1",
//     name: "General Handyman Services",
//     skills: [
//       { _id: "11", name: "Furniture Assembly" },
//       { _id: "12", name: "Hanging Pictures and Shelves" },
//       { _id: "13", name: "Door Repair" },
//       { _id: "14", name: "Lock Replacement" },
//       { _id: "15", name: "Basic Carpentry Work" },
//       { _id: "16", name: "Window Repair" },
//       { _id: "17", name: "Curtain and Blinds Installation" },
//     ],
//   },
//   {
//     _id: "2",
//     name: "Home Service",
//     skills: [
//       {
//         _id: "21",
//         name: "Home Repairs (minor fixes, patching, plumbing, etc.)",
//       },
//       { _id: "22", name: "Moving Help" },
//       { _id: "23", name: "Home Organization (closet, kitchen, etc.)" },
//       { _id: "24", name: "Appliance Installation and Repairs" },
//       { _id: "25", name: "Pest Control Assistance" },
//     ],
//   },
//   {
//     _id: "3",
//     name: "Plumbing Services",
//     skills: [
//       { _id: "31", name: "Fixing Leaks and Drips" },
//       { _id: "32", name: "Installing Faucets and Showerheads" },
//       { _id: "33", name: "Clearing Clogged Drains" },
//       { _id: "34", name: "Toilet Repair and Installation" },
//       { _id: "35", name: "Water Heater Maintenance" },
//     ],
//   },
//   {
//     _id: "4",
//     name: "Electrical Services",
//     skills: [
//       { _id: "41", name: "Installing Ceiling Fans" },
//       { _id: "42", name: "Replacing Light Fixtures" },
//       { _id: "43", name: "Electrical Outlet and Switch Repair" },
//       { _id: "44", name: "Installing Security Cameras" },
//       { _id: "45", name: "Setting Up Home Entertainment Systems" },
//     ],
//   },
//   {
//     _id: "5",
//     name: "Painting and Decorating",
//     skills: [
//       { _id: "51", name: "Interior Painting" },
//       { _id: "52", name: "Exterior Painting" },
//       { _id: "53", name: "Wallpaper Installation and Removal" },
//       { _id: "54", name: "Touch-Up Painting" },
//       { _id: "55", name: "Furniture Painting" },
//     ],
//   },
//   {
//     _id: "6",
//     name: "Cleaning Services",
//     skills: [
//       { _id: "61", name: "Deep Cleaning (Kitchens, Bathrooms, etc.)" },
//       { _id: "62", name: "Carpet and Upholstery Cleaning" },
//       { _id: "63", name: "Window Cleaning" },
//       { _id: "64", name: "Post-Renovation Cleanup" },
//       { _id: "65", name: "Garage or Attic Cleaning" },
//     ],
//   },
//   {
//     _id: "7",
//     name: "Moving Assistance",
//     skills: [
//       { _id: "71", name: "Packing and Unpacking" },
//       { _id: "72", name: "Loading and Unloading Trucks" },
//       { _id: "73", name: "Furniture Rearrangement" },
//       { _id: "74", name: "Heavy Lifting" },
//     ],
//   },
//   {
//     _id: "8",
//     name: "Outdoor Work",
//     skills: [
//       { _id: "81", name: "Gardening and Landscaping" },
//       { _id: "82", name: "Lawn Mowing and Maintenance" },
//       { _id: "83", name: "Gutter Cleaning" },
//       { _id: "84", name: "Power Washing" },
//       { _id: "85", name: "Fence Repair and Installation" },
//     ],
//   },
//   {
//     _id: "9",
//     name: "Home Renovation Support",
//     skills: [
//       { _id: "91", name: "Tile Installation and Repair" },
//       { _id: "92", name: "Drywall Patching and Repair" },
//       { _id: "93", name: "Cabinet Installation" },
//       { _id: "94", name: "Flooring Installation" },
//       { _id: "95", name: "Demolition Support" },
//     ],
//   },
//   {
//     _id: "10",
//     name: "Personal Assistance",
//     skills: [
//       { _id: "101", name: "Errand Running" },
//       { _id: "102", name: "Personal Shopping" },
//       { _id: "103", name: "Virtual Assistant (scheduling, research)" },
//       { _id: "104", name: "Pet Sitting and Walking" },
//       { _id: "105", name: "Event Assistance (decorating, planning, setup)" },
//     ],
//   },
//   {
//     _id: "11",
//     name: "Delivery Services",
//     skills: [
//       { _id: "111", name: "Grocery Shopping and Delivery" },
//       { _id: "112", name: "Food Pickup and Delivery" },
//       { _id: "113", name: "Courier Services" },
//       { _id: "114", name: "Package Delivery" },
//       { _id: "115", name: "Furniture or Large Item Delivery" },
//     ],
//   },
//   {
//     _id: "12",
//     name: "Office and Business Services",
//     skills: [
//       { _id: "121", name: "Office Cleaning" },
//       { _id: "122", name: "Administrative Support" },
//       { _id: "123", name: "IT Support (computer setup, troubleshooting)" },
//       { _id: "124", name: "Furniture Assembly for Offices" },
//       { _id: "125", name: "Data Entry" },
//       { _id: "126", name: "Business Deliveries" },
//     ],
//   },
//   {
//     _id: "13",
//     name: "Technology Support",
//     skills: [
//       { _id: "131", name: "Computer Setup and Repair" },
//       { _id: "132", name: "WiFi and Network Setup" },
//       { _id: "133", name: "TV Mounting and Home Theater Setup" },
//       { _id: "134", name: "Smartphone Assistance" },
//       { _id: "135", name: "Data Recovery" },
//     ],
//   },
//   {
//     _id: "14",
//     name: "Creative Services",
//     skills: [
//       { _id: "141", name: "Graphic Design" },
//       { _id: "142", name: "Photography and Videography" },
//       { _id: "143", name: "Content Writing" },
//       { _id: "144", name: "Web Design and Development" },
//       { _id: "145", name: "Branding and Marketing Support" },
//     ],
//   },
//   {
//     _id: "15",
//     name: "Events and Parties",
//     skills: [
//       { _id: "151", name: "Catering Assistance" },
//       { _id: "152", name: "Bartending" },
//       { _id: "153", name: "Party Setup and Cleanup" },
//       { _id: "154", name: "Event Staffing" },
//       { _id: "155", name: "Decorations and Design" },
//     ],
//   },
//   {
//     _id: "16",
//     name: "Education and Tutoring",
//     skills: [
//       { _id: "161", name: "Academic Tutoring (Math, Science, etc.)" },
//       { _id: "162", name: "Music Lessons" },
//       { _id: "163", name: "Language Tutoring" },
//       { _id: "164", name: "Test Preparation (SAT, GRE, etc.)" },
//       { _id: "165", name: "Skill-Based Training (e.g., coding, photography)" },
//     ],
//   },
//   {
//     _id: "17",
//     name: "Odd Jobs",
//     skills: [
//       { _id: "171", name: "Junk Removal" },
//       { _id: "172", name: "Heavy Lifting and Moving" },
//       { _id: "173", name: "Mounting (TVs, mirrors, shelves)" },
//       { _id: "174", name: "Snow Removal" },
//       { _id: "175", name: "Car Washing and Detailing" },
//     ],
//   },
//   {
//     _id: "18",
//     name: "Lifestyle Services",
//     skills: [
//       { _id: "181", name: "Interior Decorating" },
//       { _id: "182", name: "Fitness Training" },
//       { _id: "183", name: "Nutrition Coaching" },
//       { _id: "184", name: "Life Coaching" },
//       { _id: "185", name: "Childcare and Babysitting" },
//     ],
//   },
//   {
//     _id: "19",
//     name: "Specialized Services",
//     skills: [
//       { _id: "191", name: "Legal Document Assistance" },
//       { _id: "192", name: "Accounting and Tax Preparation" },
//       { _id: "193", name: "Translation Services" },
//       { _id: "194", name: "Notary Services" },
//       { _id: "195", name: "Health and Wellness Coaching" },
//     ],
//   },
//   {
//     _id: "20",
//     name: "Tailor Services",
//     skills: [
//       { _id: "201", name: "Custom Suit Design" },
//       { _id: "202", name: "Alterations and Repairs" },
//       { _id: "203", name: "Wedding Dress Tailoring" },
//       { _id: "204", name: "Bespoke Shirt Making" },
//       { _id: "205", name: "Embroidery Services" },
//       { _id: "206", name: "Clothing Resizing" },
//       { _id: "207", name: "Curtain and Upholstery Tailoring" }
//     ],
//   },
//   {
//     _id: "21",
//     name: "Photography Services",
//     skills: [
//       { _id: "211", name: "Wedding Photography" },
//       { _id: "212", name: "Portrait Photography" },
//       { _id: "213", name: "Event Photography" },
//       { _id: "214", name: "Product Photography" },
//       { _id: "215", name: "Real Estate Photography" },
//       { _id: "216", name: "Aerial and Drone Photography" },
//       { _id: "217", name: "Photo Editing and Retouching" }
//     ],
//   },
//   {
//     _id: "22",
//     name: "Gardening Services",
//     skills: [
//       { _id: "221", name: "Landscape Design" },
//       { _id: "222", name: "Lawn Maintenance" },
//       { _id: "223", name: "Planting and Transplanting" },
//       { _id: "224", name: "Tree and Shrub Care" },
//       { _id: "225", name: "Weed Control" },
//       { _id: "226", name: "Irrigation System Installation" },
//       { _id: "227", name: "Garden Pest Management" }
//     ],
//   } 
// ];

// NOTE: updated >>>>>>>>>>
export const categories = [
  {
    _id: "1",
    name: "General Handyman Services",
    skills: [
      { _id: "11", name: "Furniture Assembly" },
      { _id: "12", name: "Hanging Pictures and Shelves" },
      { _id: "13", name: "Door Repair" },
      { _id: "14", name: "Lock Replacement" },
      { _id: "15", name: "Basic Carpentry Work" },
      { _id: "16", name: "Window Repair" },
      { _id: "17", name: "Curtain and Blinds Installation" },
      {_id: "18", name: "Tile Installation and Repair" },
      {_id: "19", name: "Drywall Patching and Repair" },
      {_id: "110", name: "Cabinet Installation" },
      {_id: "111", name: "Flooring Installation" },
      {_id: "112", name: "Demolition Support" },
      {_id: "113", name: "Home Organization (closet, kitchen, etc.)" },
      {_id: "114", name: "Appliance Installation and Repairs" },
      {_id: "115", name: "Mounting (TVs, mirrors, shelves)" },
      {_id: "116", name: "Ceiling fan installation " },
    ],
  },
  {
    _id: "2",
    name: "Plumbing Services",
    skills: [
      { _id: "21", name: "Fixing Leaks and Drips" },
      { _id: "22", name: "Installing Faucets and Showerheads" },
      { _id: "23", name: "Clearing Clogged Drains" },
      { _id: "24", name: "Toilet Repair and Installation" },
      { _id: "25", name: "Water Heater Maintenance" },
    ],
  },
  {
    _id: "3",
    name: "Electrical Services",
    skills: [
      { _id: "31", name: "Installing Ceiling Fans" },
      { _id: "32", name: "Replacing Light Fixtures" },
      { _id: "33", name: "Electrical Outlet and Switch Repair" },
      { _id: "34", name: "Installing Security Cameras" },
      { _id: "35", name: "Setting Up Home Entertainment Systems" },
    ],
  },
  {
    _id: "4",
    name: "Painting and Decorating",
    skills: [
      { _id: "41", name: "Interior Painting" },
      { _id: "42", name: "Exterior Painting" },
      { _id: "43", name: "Wallpaper Installation and Removal" },
      { _id: "44", name: "Touch-Up Painting" },
      { _id: "45", name: "Furniture Painting" },
    ],
  },
  {
    _id: "5",
    name: "Cleaning Services",
    skills: [
      { _id: "51", name: "Deep Cleaning (Kitchens, Bathrooms, etc.)" },
      { _id: "52", name: "Carpet Cleaning" },
      { _id: "53", name: "Window Cleaning" },
      { _id: "54", name: "Post-Renovation Clean up" },
      { _id: "55", name: "Garage Cleaning" },
      { _id: "56", name: "Car washing" },
      { _id: "57", name: "Car Detailing" },
      { _id: "58", name: "House cleaning" },
      { _id: "59", name: "Disinfecting services" },
      { _id: "510", name: "Laundry help" },
    ],
  },
  {
    _id: "6",
    name: "Moving Assistance",
    skills: [
      { _id: "61", name: "Packing services" },
      { _id: "62", name: "Unpacking services" },
      { _id: "63", name: "Loading and Unloading Trucks" },
      { _id: "64", name: "Furniture Rearrangement" },
      { _id: "65", name: "Heavy Lifting" },
      {_id: "66", name: "Moving Help" },
      {_id: "67", name: "Heavy Lifting and Moving" },
      {_id: "68", name: "Junk Removal" },
      {_id: "69", name: "Full service movers" },
    ],
  },
  {
    _id: "7",
    name: "Outdoor Work",
    skills: [
      { _id: "71", name: "Gardening" },
      { _id: "72", name: "Landscaping" },
      { _id: "73", name: "Lawn Mowing" },
      { _id: "74", name: "Maintenance" },
      { _id: "75", name: "Gutter Cleaning" },
      { _id: "76", "name": "Power Washing" },
      { _id: "77", "name": "Fence Repair" },
      { _id: "78", "name": "Fence Installation" },
      { _id: "79", "name": "Tree Trimming" },
      { _id: "710", "name": "Hedge Trimming" }
    ],
  },
  {
    _id: "8",
    name: "Shopping + Delivery Services",
    skills: [
      { _id: "81", name: "Grocery Shopping and Delivery" },
      { _id: "82", name: "Food Pickup and Delivery" },
      { _id: "83", name: "Courier Services" },
      { _id: "84", name: "Package Delivery" },
      { _id: "85", name: "Furniture or Large Item Delivery" },
      { _id: "86", name: "Errand running" },
    ],
  },
  {
    _id: "9",
    name: "Office and Business Services",
    skills: [
      { _id: "91", name: "Office Cleaning" },
      { _id: "92", name: "Administrative Support" },
      { _id: "93", name: "IT Support (computer setup, troubleshooting)" },
      { _id: "94", name: "Furniture Assembly for Offices" },
      { _id: "95", name: "Business Deliveries" },
    ],
  },
  {
    _id: "10",
    name: "Events and Parties",
    skills: [
      { _id: "101", name: "Catering Assistance" },
      { _id: "102", name: "Bartending" },
      { _id: "103", name: "Party Setup and Clean up" },
      { _id: "104", name: "Event Staffing" },
      { _id: "105", name: "Decorations and Design" },
    ],
  },
  {
    _id: "11",
    name: "Tailors",
    skills: [
      { _id: "1101", name: "Clothing Alteration" },
      { _id: "1102", name: "Wedding dresses" },
      { _id: "1103", name: "Bespoke tailoring" },
    ],
  },
];


export const cities = [
  {
    _id: "1",
    name: "Accra",
    subcities: [
      { _id: "11", name: "Adenta" },
      { _id: "12", name: "Madina" },
      { _id: "13", name: "Tema" },
      { _id: "14", name: "Teshie" },
      { _id: "15", name: "Nungua" },
      { _id: "16", name: "Ashaiman" },
      { _id: "17", name: "Dansoman" },
      { _id: "18", name: "Spintex" },
      { _id: "19", name: "Osu" },
      { _id: "110", name: "East Legon" },
    ],
  },
  {
    _id: "2",
    name: "Kumasi",
    subcities: [
      { _id: "21", name: "Bantama" },
      { _id: "22", name: "Suame" },
      { _id: "23", name: "Oforikrom" },
      { _id: "24", name: "Asokwa" },
      { _id: "25", name: "Kwadaso" },
      { _id: "26", name: "Ejisu" },
      { _id: "27", name: "Manhyia" },
    ],
  },
  {
    _id: "3",
    name: "Sekondi-Takoradi",
    subcities: [
      { _id: "31", name: "Effia" },
      { _id: "32", name: "Kwesimintsim" },
      { _id: "33", name: "Shama" },
      { _id: "34", name: "Agona Nkwanta" },
    ],
  },
  {
    _id: "4",
    name: "Cape Coast",
    subcities: [
      { _id: "41", name: "Elmina" },
      { _id: "42", name: "Mankessim" },
      { _id: "43", name: "Kasoa" },
      { _id: "44", name: "Saltpond" },
    ],
  },
  {
    _id: "5",
    name: "Koforidua",
    subcities: [
      { _id: "51", name: "New Juaben" },
      { _id: "52", name: "Nsawam" },
      { _id: "53", name: "Aburi" },
      { _id: "54", name: "Suhum" },
    ],
  },
  {
    _id: "6",
    name: "Tamale",
    subcities: [
      { _id: "61", name: "Sagnarigu" },
      { _id: "62", name: "Yendi" },
      { _id: "63", name: "Savelugu" },
    ],
  },
  {
    _id: "7",
    name: "Ho",
    subcities: [
      { _id: "71", name: "Keta" },
      { _id: "72", name: "Hohoe" },
      { _id: "73", name: "Aflao" },
    ],
  },
  {
    _id: "8",
    name: "Bolgatanga",
    subcities: [
      { _id: "81", name: "Bawku" },
      { _id: "82", name: "Navrongo" },
    ],
  },
  {
    _id: "9",
    name: "Wa",
    subcities: [
      { _id: "91", name: "Nadowli" },
      { _id: "92", name: "Tumu" },
    ],
  },
  {
    _id: "10",
    name: "Sunyani",
    subcities: [
      { _id: "101", name: "Berekum" },
      { _id: "102", name: "Dormaa Ahenkro" },
    ],
  },
  {
    _id: "11",
    name: "Goaso",
    subcities: [
      { _id: "111", name: "Hwidiem" },
      { _id: "112", name: "Mim" },
    ],
  },
  {
    _id: "12",
    name: "Techiman",
    subcities: [
      { _id: "121", name: "Kintampo" },
      { _id: "122", name: "Nkoranza" },
    ],
  },
  {
    _id: "13",
    name: "Damongo",
    subcities: [
      { _id: "131", name: "Bole" },
      { _id: "132", name: "Salaga" },
    ],
  },
  {
    _id: "14",
    name: "Nalerigu",
    subcities: [
      { _id: "141", name: "Walewale" },
      { _id: "142", name: "Gambaga" },
    ],
  },
  {
    _id: "15",
    name: "Sefwi Wiawso",
    subcities: [
      { _id: "151", name: "Bibiani" },
      { _id: "152", name: "Enchi" },
    ],
  },
  {
    _id: "16",
    name: "Dambai",
    subcities: [
      { _id: "161", name: "Kete Krachi" },
      { _id: "162", name: "Nkwanta" },
    ],
  },
];

// INFO: Paystack Mobile Money Providers in Ghana
export const mobileMoneyProviders = [
  {
    _id: "MTN",
    name: "MTN Mobile Money (MTN MoMo)",
  },
  {
    _id: "AIRTEL",
    name: "AirtelTigo Money",
  },
  {
    _id: "VODAFONE",
    name: "Vodafone Cash",
  },
];

// INFO: Ghana Banks
export const banks = [
  { _id: "1", name: "GCB Bank" },
  { _id: "2", name: "Absa Bank Ghana" },
  { _id: "3", name: "Stanbic Bank Ghana" },
  { _id: "4", name: "Ecobank Ghana" },
  { _id: "5", name: "Fidelity Bank Ghana" },
  { _id: "6", name: "CalBank" },
  { _id: "7", name: "Zenith Bank Ghana" },
  { _id: "8", name: "Access Bank Ghana" },
  { _id: "9", name: "Republic Bank Ghana" },
  { _id: "10", name: "First National Bank Ghana" },
  { _id: "11", name: "United Bank for Africa (UBA) Ghana" },
  { _id: "12", name: "Societe Generale Ghana" },
  { _id: "13", name: "Guaranty Trust Bank (GTBank) Ghana" },
  { _id: "14", name: "Standard Chartered Bank Ghana" },
  { _id: "15", name: "First Atlantic Bank" },
  { _id: "16", name: "Consolidated Bank Ghana (CBG)" },
  { _id: "17", name: "OmniBSIC Bank" },
  { _id: "18", name: "Universal Merchant Bank (UMB)" },
  { _id: "19", name: "Prudential Bank" },
  { _id: "20", name: "National Investment Bank (NIB)" },
];

export const firebaseUplaodFolders = {
  F_ID_IMAGES: "idimages",
  F_OFFERS: "offers",
  F_ORDERS: "orders",
  F_PROFILE_PICTURES: "profilepictures",
  F_COMPLAINTS: "complaints",
  F_ISSUES: "issues",
  F_MESSAGES: "messages",
  F_REFERENCES: "references",  
  F_JOB_POSTS: "jobposts",
  F_ADDRESS_PROOF: "addressproof",
};

// INFO: complaint reasons types
export const complaintReasons = [
  { _id: "1", reason: "Incomplete cleaning" },
  { _id: "2", reason: "Damaged property" },
  { _id: "3", reason: "Late arrival" },
  { _id: "4", reason: "Unprofessional behavior" },
  { _id: "5", reason: "Plants damaged" },
  { _id: "6", reason: "Incomplete work" },
  { _id: "7", reason: "Tools left behind" },
  { _id: "8", reason: "Overcharged" },
  { _id: "9", reason: "Leaking pipes after service" },
  { _id: "10", reason: "Incomplete repair" },
  { _id: "11", reason: "Wrong part used" },
];

// INFO: complaint resolving reasons types
export const complaintResolvingOptions = [
  { _id: "1", name: "Full refund processed" },
  { _id: "2", name: "half refund processed" },
  { _id: "3", name: "Customized solution provided" },
  { _id: "4", name: "Invalid complain" },
  { _id: "5", name: "Service reattempted and completed" },
];

// INFO: Service Pro Level
export const serviceProLevels = [
  { _id: "1", name: "Level 01" },
  { _id: "2", name: "Level 02" },
  { _id: "3", name: "Level 03" },
  { _id: "4", name: "Level 04" },
  { _id: "5", name: "Level 05" },
]

// INFO: Registered service providers status
export const registeredTaskerDropDownStatus = [
  { name: "Active", value: "false" },
  { name: "Suspended", value: "true" },
];

export const paymentTypes = {
  BANK: 'BANK',
  MOBILE_MONEY: 'MOBILE_MONEY',
}

export const GENRES_LIST = [
	{
		id: "all",
		name: "All Genres",
		code: "#000000",
	},
	{
		id: "hiphop",
		name: "Hip-Hop",
		code: "#E63946",
	},
	{
		id: "randb",
		name: "R&B",
		code: "#E63946",
	},
	{
		id: "latin",
		name: "Latin",
		code: "#6A0DAD",
	},
	{
		id: "electronic",
		name: "Electronic",
		code: "#007BFF",
	},
	{
		id: "dance",
		name: "Dance",
		code: "#007BFF",
	},
	{
		id: "international",
		name: "International",
		code: "#FFFF00",
	},
	{
		id: "reggae",
		name: "Reggae",
		code: "#32CD32",
	},
	{
		id: "dancehall",
		name: "Dancehall",
		code: "#32CD32",
	},
	{
		id: "pop",
		name: "Pop",
		code: "#FF1493",
	},
	{
		id: "top100",
		name: "Top 100",
		code: "#FF1493",
	},
];

export const Timespan = [
  {
		name: "7",
	},
	{
		name: "30",
	},
	{
		name: "90",
	},
	{
		name: "365",
	},
]